import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import RotationMeter from '../../objects/kpi/RotationKpiMeter';
import * as learningPlanConstants from '../../../constants/learningPlanConstants';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as kpiModels from '../../../models/kpiModels';
import * as kpiConstants from '../../../constants/kpiConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as appConstants from '../../../constants/appConstants';
import * as keyboardConstants from '../../../constants/keyboardConstants';

class LearninPlanBiteHotSpotMobile extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            filter: props.filter,

            userBite: props.userBite,
            lang: props.lang,
            hotspotSettings: props.hotspotSettings,
            locale: appHelper.getLocalData(this.props.menuData),
            biteLocale: appHelper.getLocalData(this.props.bite),
            primaryKpi: appHelper.isDefined(this.props.bite.score_kpi) ? this.props.bite.score_kpi : {},
            performance_kpis: appHelper.isDefined(this.props.bite.performance_kpis) && this.props.bite.performance_kpis.length ? this.props.bite.performance_kpis : [],
            feedback_styles: this.props.contentData.experience.feedback_styles,
            assets: {
                thumbnail: {
                    src: "",
                    type: "",
                    type_id: ""
                },
                icon: {
                    src: "",
                    type: "",
                    type_id: ""
                }
            },
            checkForUpdate: false,
            badges: this.props.bite.badges,
            showAchievedCount: true,
            showAchievedState: true,
            isEnabled: false,
            updateEnabledBite: false,
            optionLabel: appHelper.getLocaleString("optional_label"),
            start_label: appHelper.getLocaleString("start_label"),
            continue_label: appHelper.getLocaleString("continue_label"),
            review_label: appHelper.getLocaleString("review_label"),
            tooltipClass: "tooltip-closed",
            tooltipLocation: "bottom center",
            coordinates: {},
            button_label: appHelper.getLocaleString("start_label"),
            setButtonLabel: false,
        };

        this.hotspot = React.createRef();

        this.getAssets = this.getAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.setBite = this.setBite.bind(this);
        this.goToBite = this.goToBite.bind(this);
        this.getUserProgressClass = this.getUserProgressClass.bind(this);
        this.setEnabledState = this.setEnabledState.bind(this);
        this.isBiteEnabled = this.isBiteEnabled.bind(this);
        this.getBiteEnabledState = this.getBiteEnabledState.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.toggleToolTip = this.toggleToolTip.bind(this);
        this.setKeyboardToggleToolTip = this.setKeyboardToggleToolTip.bind(this);
        this.getHotspotButtonType = this.getHotspotButtonType.bind(this);
        this.getHotSpotColour = this.getHotSpotColour.bind(this);
        this.getHotSpotBorderColour = this.getHotSpotBorderColour.bind(this);
        this.getButtonLabel = this.getButtonLabel.bind(this);
        this.getColourValue = this.getColourValue.bind(this);

    }

    componentDidMount() {
        if (this.state.userBite.visible) {
            this.getAssets();
            this.setEnabledState();
            this.getButtonLabel();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.filter !== nextProps.filter) {
            this.setState({filter: nextProps.filter});
        }
        if (this.state.userBite !== nextProps.userBite) {
            this.setState({
                userBite: Object.assign({}, nextProps.userBite),
                updateEnabledBite: true,
                setButtonLabel: true,
            });
        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.props.menuData),
                biteLocale: appHelper.getLocalData(this.props.bite),
                optionLabel: appHelper.getLocaleString("optional_label"),
                start_label: appHelper.getLocaleString("start_label"),
                continue_label: appHelper.getLocaleString("continue_label"),
                review_label: appHelper.getLocaleString("review_label"),
                setButtonLabel: true,
            });
        }
        if (this.state.hotspotSettings !== nextProps.hotspotSettings) {
            this.setState({
                hotspotSettings: nextProps.hotspotSettings,
            });
        }

        this.setEnabledState();
    }

    componentDidUpdate() {
        if (this.state.checkForUpdate && this.props.trackingData.lesson_location === this.props.bite.screens[0].screen_id) {
            this.goToBite();
        }

        if (this.state.updateEnabledBite) {
            this.setEnabledState();
        }

        if (this.state.setButtonLabel) {
            this.getButtonLabel();
        }
    }

    getAssets() {
        let iconAsset = appHelper.getIconAsset(this.props.menuData.icon);
        this.setState({
            assets: Object.assign({}, this.state.assets, {
                icon: iconAsset
            })
        });
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setBite() {

        if (this.isBiteEnabled()) {
            let screen_id = this.props.bite.screens[0].screen_id;
            this.props.actions.setNewLessonLocation(screen_id);
            this.setState({checkForUpdate: true});
            //this.context.router.push(this.props.bite.bite_id);

        }
    }

    goToBite() {
        this.setState({checkForUpdate: false});
        this.context.router.push(this.props.bite.bite_id);
    }

    getUserProgressClass() {
        let className = ``;

        if (this.state.userBite.status === objectConstants.STATUS_NOT_REQUIRED) {
            className += `${objectConstants.CLASS_NOT_REQUIRED} `;
        } else if (this.state.userBite.status === objectConstants.STATUS_IN_PROGRESS) {
            className += `${objectConstants.CLASS_IN_PROGRESS} `;
        } else if (this.state.userBite.status === objectConstants.STATUS_COMPLETE) {
            className += `${objectConstants.CLASS_COMPLETE} `;
        } else {
            className += `${objectConstants.CLASS_NOT_STARTED} `;
        }

        return className;
    }

    setEnabledState() {
        this.setState({
            updateEnabledBite: false
        });
        let isEnabled = false;
        switch (this.props.learningPlan.navigation_type) {
            case learningPlanConstants.LP_NAVIGATION_TYPE_LINEAR:
                isEnabled = appHelper.checkLinearMenuBiteEnabled(this.state.userBite, this.props.userData, this.props.learningPlanBites);
                break;
            case learningPlanConstants.LP_NAVIGATION_TYPE_OPEN:
                isEnabled = appHelper.checkOpenMenuBiteEnabled(this.state.userBite, this.props.userData);
                break;
            case learningPlanConstants.LP_NAVIGATION_TYPE_FIRST_ANY_LAST:
                isEnabled = appHelper.checkFirstLastAnyMenuBiteEnabled(this.state.userBite, this.props.userData, this.props.learningPlanBites);
                break;
            default:
                isEnabled = appHelper.checkLinearMenuBiteEnabled(this.state.userBite, this.props.userData, this.props.learningPlanBites);
        }

        this.setState({isEnabled: isEnabled});
    }

    isBiteEnabled() {
        return this.state.isEnabled;
    }

    getBiteEnabledState() {
        return this.isBiteEnabled() ? "" : "disabled";
    }

    getButtonLabel() {
        let button_label = this.state.button_label;

        if (this.state.userBite.status === objectConstants.STATUS_IN_PROGRESS) {
            button_label = this.state.continue_label;
        } else if (this.state.userBite.status === objectConstants.STATUS_COMPLETE) {
            button_label = this.state.review_label;
        }

        this.setState({
            button_label: button_label,
            setButtonLabel: false,
        });


    }

    setKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            event.stopPropagation();
            this.setBite();
        }
    }

    // <InlineSVG className="guroo-icon" src={this.getImagePath(this.state.assets.icon.src)}/>

    getHotspotButtonType() {
        let returnVal = "";
        switch (this.props.learningPlan.bite_hotspot_type) {
            case learningPlanConstants.LP_GAMEBOARD_HOTSPOT_TYPE_CHECK_ROLLOVER:
                returnVal = "hot-spot-hide";
                break;
            case learningPlanConstants.LP_GAMEBOARD_HOTSPOT_TYPE_CHECK_LABEL:
                returnVal = "hot-spot";
                break;
            case learningPlanConstants.LP_GAMEBOARD_HOTSPOT_TYPE_SMALL_ICON:
                returnVal = "hot-spot-sml-icon";
                break;
            case learningPlanConstants.LP_GAMEBOARD_HOTSPOT_TYPE_SMALL_ICON_LABEL:
                returnVal = "hot-spot-sml";
                break;
            case learningPlanConstants.LP_GAMEBOARD_HOTSPOT_TYPE_LARGE_ICON:
                returnVal = "hot-spot-lg icon-only";
                break;
            case learningPlanConstants.LP_GAMEBOARD_HOTSPOT_TYPE_LARGE_ICON_LABEL:
                returnVal = "hot-spot-lg";
                break;
            case learningPlanConstants.LP_GAMEBOARD_HOTSPOT_TYPE_ROUND_ICON:
                returnVal = "hot-spot-round icon-only";
                break;
            case learningPlanConstants.LP_GAMEBOARD_HOTSPOT_TYPE_ROUND_ICON_LABEL:
                returnVal = "hot-spot-round";
                break;
            case learningPlanConstants.LP_GAMEBOARD_HOTSPOT_TYPE_SMALL_ICON_RECTANGLE_BUTTON:
                returnVal = "hot-spot-sml-icon-btn";
                break;
        }
        return returnVal;
    }

    getHotSpotColour() {
        /*let buttonColour = "#33333";
        let labelColour = "#ffffff";
        if(appHelper.isDefined(this.state.theme.variables_v2)) {
            buttonColour = appHelper.isDefined(this.props.learningPlan.hotspot_colour) && this.state.screen.content.hotspot_colour !== screenConstants.INHERIT_FROM_THEME ? this.props.learningPlan.hotspot_colour : this.state.theme.variables_v2.buttons_and_links.buttons.active_color;
            labelColour = appHelper.isDefined(this.props.learningPlan.hotspot_label_colour) && this.state.screen.content.hotspot_label_colour !== screenConstants.INHERIT_FROM_THEME ? this.props.learningPlan.hotspot_label_colour : this.state.theme.variables_v2.buttons_and_links.buttons.text_color;
        }

        return {
            background: buttonColour,
            color: labelColour
        };
        return {};*/
    }

    getHotSpotBorderColour() {
        /*let borderColour = "#ffffff";
        if(appHelper.isDefined(this.state.theme.variables_v2)) {
            borderColour = appHelper.isDefined(this.state.screen.content.hotspot_label_colour) && this.state.screen.content.hotspot_label_colour !== screenConstants.INHERIT_FROM_THEME ? this.state.screen.content.hotspot_label_colour : this.state.theme.variables_v2.buttons_and_links.buttons.text_color;
        }
        return {
            borderColor:  borderColour
        };*/
        return {};
    }

    toggleToolTip(event) {
        if (appHelper.isDefined(event)) {
            event.stopPropagation();
        }
        let className = "tooltip-closed";

        if (this.state.tooltipClass === "tooltip-closed") {
            className = "tooltip-open";
        }
        this.setState({tooltipClass: className});
    }

    setKeyboardToggleToolTip(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            event.stopPropagation();
            this.toggleToolTip(event);
        }
    }

    getColourValue(value) {
        if (typeof value === "string") {
            return value;
        } else {
            if (appHelper.isDefined(value.r)) {
                if (appHelper.isDefined(value.a)) {
                    return `rgba(${value.r},${value.g},${value.b},${value.a})`;
                } else {
                    return `rgb(${value.r},${value.g},${value.b})`;
                }
            }

        }
    }

    render() {
        return (
            this.state.userBite.visible
                ?
                <div className={`bite-hotspot ${this.state.tooltipClass}`} ref={this.hotspot} onClick={this.setBite}
                     onKeyDown={this.setKeyboardAccessibility} tabIndex={0} role="link">
                    <div className={`${this.getHotspotButtonType()}  ${this.getBiteEnabledState()}`}>


                        <div className={`hot-spot-body ${this.getUserProgressClass()}`}>

                            <div className="disabled-indicator">
                                <div className="indicator"/>
                            </div>
                            <div className="status-indicator">
                                <div className={`indicator ${this.getUserProgressClass()}`}/>
                            </div>
                            <div className="hot-spot-icon-container">
                                <div className="icon-more-info-btn" onClick={this.toggleToolTip}
                                     onKeyDown={this.setKeyboardToggleToolTip} tabIndex={0} role="link"/>
                                <div className="hot-spot-icon">

                                    <div className="menu-icon-container">
                                        {
                                            appHelper.isDefined(this.state.assets.icon)
                                                ?
                                                <img className="guroo-icon"
                                                     src={this.getImagePath(this.state.assets.icon.src)} alt=""/>
                                                :
                                                null
                                        }

                                    </div>
                                </div>
                            </div>
                            <div className="hot-spot-content">
                                <div className={`hot-spot-label`}>

                                    <div>
                                        <div className="learning-plan-bite-static-title"
                                             dangerouslySetInnerHTML={{__html: this.state.biteLocale.title}}/>
                                    </div>
                                    <div>
                                        <div className="more-info" onClick={this.toggleToolTip}
                                             onKeyDown={this.setKeyboardToggleToolTip} tabIndex={0} role="link"/>
                                    </div>
                                </div>
                                <div className="more-info-btn" onClick={this.toggleToolTip}
                                     onKeyDown={this.setKeyboardToggleToolTip} tabIndex={0} role="link"/>
                                <div className="progress-container">
                                    <div className="progress-indicator">
                                        <div className={`progress-meter ${this.getUserProgressClass()}`}/>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className={`hot-spot-tool-tip ${this.state.tooltipLocation}`}>
                        <div className="close-btn" onClick={this.toggleToolTip}
                             onKeyDown={this.setKeyboardToggleToolTip}
                             tabIndex={0} role="link"/>

                        {!this.props.required
                            ?
                            <span className="optional-indicator">{this.state.optionLabel}</span>
                            :
                            null
                        }

                        <div className="bite-title">
                            <p dangerouslySetInnerHTML={{__html: this.state.biteLocale.title}}/>
                        </div>

                        <div className={`bite-description`}>
                            <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                        </div>

                        <div className="text-center">
                            <button className={`btn guroo-btn`} onClick={this.setBite}
                                    disabled={!this.isBiteEnabled()}>{this.state.button_label}</button>
                        </div>

                        <div className="scoring-container">
                            {this.props.learningPlan.kpi_display === learningPlanConstants.LP_PRIMARY_KPI_DISPLAY_BITE_MENU && appHelper.isDefined(this.state.primaryKpi.kpi_id) && this.state.primaryKpi.kpi_id !== null && this.state.primaryKpi.is_visible
                                ?
                                <div className="scoring-col">
                                    <RotationMeter bite_id={this.props.bite.bite_id}
                                                   kpiDefaults={this.state.primaryKpi}
                                                   meterParams={kpiModels.SMALL_KPI_ROTATION_METER_PARAMS}
                                                   displayState={kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL}/>
                                </div>
                                :
                                null
                            }

                            {this.state.badges.length > 0 && (this.props.learningPlan.badge_display === learningPlanConstants.LP_BADGE_DISPLAY_BITE_MENU || this.props.learningPlan.badge_display === learningPlanConstants.LP_BADGE_DISPLAY_HEADER_AND_BITE)
                                ?
                                <div className="scoring-col">
                                    <div className="earned-badges">
                                        <div className="icon icons8-achievement-filled" role="presentation"/>
                                        <div className="badge-count">
                                    <span className="status-indicator">
                                    {this.state.badges.length.toString()}
                                    </span>
                                        </div>
                                    </div>
                                </div>
                                :
                                null
                            }
                        </div>
                    </div>
                    <style>
                        {`\
                        .hot-spot-sml .progress-meter.in-progress,
                        .hot-spot-lg .progress-meter.in-progress,
                        .hot-spot-round .progress-meter.in-progress{\
                            background: ${this.getColourValue(this.state.feedback_styles.yellow_feedback.colors.color)} !important;\
                        }\

                        .hot-spot-sml .progress-meter.complete,
                        .hot-spot-lg .progress-meter.complete,
                        .hot-spot-round .progress-meter.complete{\
                            background: ${this.getColourValue(this.state.feedback_styles.green_feedback.colors.color)} !important;\
                        }\

                        .hot-spot .hot-spot-body,
                        .hot-spot-hide .hot-spot-body,
                        .hot-spot-sml .hot-spot-body,
                        .hot-spot-sml-icon .hot-spot-body,
                        .hot-spot-hide .hot-spot-body .hot-spot-label,
                        .hot-spot-sml-icon-btn .hot-spot-body,
                        .hot-spot-lg .hot-spot-body .hot-spot-content,
                        .hot-spot-round .hot-spot-body .hot-spot-content{\
                           ${this.props.learningPlan.hotspot_colour !== objectConstants.INHERIT ? `background: ${this.getColourValue(this.props.learningPlan.hotspot_colour)} !important;` : null}\
                           ${this.props.learningPlan.hotspot_label_colour !== objectConstants.INHERIT ? `color: ${this.getColourValue(this.props.learningPlan.hotspot_label_colour)} !important;` : null}\

                        }\

                        .hot-spot-sml-icon-btn .hot-spot-body .hot-spot-content,
                        .hot-spot-sml-icon-btn .hot-spot-body .hot-spot-content .hot-spot-label,
                        .hot-spot-sml-icon-btn .hot-spot-body .hot-spot-content .hot-spot-label .learning-plan-bite-static-title {\
                           ${this.props.learningPlan.hotspot_label_colour !== objectConstants.INHERIT ? `color: ${this.getColourValue(this.props.learningPlan.hotspot_label_colour)} !important;` : null}\
                         }\


                        .hot-spot-sml-icon .hot-spot-body{\
                             ${this.props.learningPlan.hotspot_colour !== objectConstants.INHERIT ? `border-color: ${this.getColourValue(this.props.learningPlan.hotspot_colour)} !important;` : null}\
                        }\
                        .hot-spot-sml-icon-btn .hot-spot-body.in-progress .hot-spot-icon-container:after,
                        .hot-spot-sml-icon .hot-spot-body.in-progress:after{\
                            border-top-color: ${this.getColourValue(this.state.feedback_styles.yellow_feedback.colors.color)} !important;\
                            border-left-color: ${this.getColourValue(this.state.feedback_styles.yellow_feedback.colors.color)} !important;\
                        }\
                        .hot-spot-sml-icon-btn .hot-spot-body.complete .hot-spot-icon-container:before,
                         .hot-spot-sml-icon .hot-spot-body.complete:before{\
                            border-color: ${this.getColourValue(this.state.feedback_styles.green_feedback.colors.color)} !important;\
                        }\

                        .hot-spot-sml .hot-spot-body .hot-spot-icon  .menu-icon-container,
                        .hot-spot-lg .hot-spot-body .hot-spot-icon   .menu-icon-container,
                         .hot-spot-sml-icon-btn .hot-spot-body .hot-spot-icon-container,
                        .hot-spot-round .hot-spot-body .hot-spot-icon  .menu-icon-container{\
                            background: ${this.getColourValue(this.props.learningPlan.hotspot_icon_bg_colour)} !important;\
                            border-color: ${this.getColourValue(this.props.learningPlan.hotspot_icon_border_colour)} !important;\
                        }\

                        .hot-spot-tool-tip .guroo-btn{\
                           ${this.props.learningPlan.hotspot_colour !== objectConstants.INHERIT ? `background: ${this.getColourValue(this.props.learningPlan.hotspot_colour)} !important;` : null}\
                           ${this.props.learningPlan.hotspot_label_colour !== objectConstants.INHERIT ? `color: ${this.getColourValue(this.props.learningPlan.hotspot_label_colour)} !important;` : null}\
                        }\
                      `}
                    </style>
                </div>
                :
                null


        );
    }
}


/*
* {this.state.performance_kpis.length > 0
                                    ?
                                    this.state.performance_kpis.map(kpi =>
                                    <div className="kpi-meter-container" key={kpi.kpi_id}>
                                        <div className="kpi-meter">
                                            <RotationMeter bite_id={this.props.bite.bite_id}
                                                           kpiDefaults={kpi}
                                                           meterParams={kpiModels.DEFAULT_KPI_ROTATION_METER_PARAMS}
                                                           displayState={kpiConstants.KPI_DISPLAY_STATE_CURRENT_VALUE_NO_LABEL}/>
                                        </div>
                                    </div>
                                     )
                                    :null
                                }

* */
LearninPlanBiteHotSpotMobile.propTypes = {
    menuData: PropTypes.object.isRequired,
    bite: PropTypes.object.isRequired,
    required: PropTypes.bool.isRequired,
    filter: PropTypes.string.isRequired,
    userBite: PropTypes.object.isRequired,
    learningPlan: PropTypes.object.isRequired,
    learningPlanBites: PropTypes.array.isRequired,
    hotspotSettings: PropTypes.object,
    userData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

LearninPlanBiteHotSpotMobile.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        userBite: userDataHelper.getBiteUserData(state.userData, ownProps.bite.bite_id),
        userData: state.userData,
        trackingData: state.trackingData,
        contentData: state.contentData

    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LearninPlanBiteHotSpotMobile);



/** WEBPACK FOOTER **
 ** ./src/components/menus/learningPlan/LearninPlanBiteHotSpotMobile.js
 **/